module.exports = __webpack_public_path__ + "img/garanti_bbva_logo.d2b0874a.svg";